<template>
  <div class="remoteBank-container">
    <div class="pc d-none d-lg-block">
      <div class="container" data-aos="fade-left" :data-aos-duration="2 * 1000">
        <div class="content-left">
          <p class="title">远程银行</p>
          <p class="subtitle">
            提供远程银行解决方案，以“连接+智能服务”为核心的新一<br />代金融服务为银行用户提供数字化、线上化、视频化、智能<br />化、个性化的解决方案。
          </p>
          <p class="btn-text" @click="open">了解更多 →</p>
        </div>
        <div class="content-right">
          <img src="https://zealcomm-site-assets.zealcomm.cn/new-product/remote-banking.png" alt="" />
        </div>
      </div>
    </div>
    <div class="d-lg-none mobile">
      <div class="container" data-aos="fade-left" :data-aos-duration="2 * 1000">
        <div class="top">
          <p class="title">远程银行</p>
          <p class="subtitle">
            提供远程银行解决方案，以“连接+智能服务”为核心的新一代金融服务为银行用户提供数字化、线上化、视频化、智能化、个性化的解决方案。
          </p>
          <p class="btn-text" @click="open">了解更多 →</p>
        </div>
        <div class="bottom">
          <img src="~assets/img/solution/remoteBank-mobile.png" alt="" />
        </div>
      </div>
    </div>
    <Form v-model="show" />
  </div>
</template>

<script>
  import Form from "@/components/Form/index.vue";
  export default {
    data() {
      return {
        show: false,
      };
    },
    components: {
      Form,
    },
    methods: {
      open() {
        if (typeof this.customBtnClick === "function") {
          this.customBtnClick.call();
        } else {
          this.show = true;
        }
      },
    },
  };
</script>

<style scoped lang="scss">
  .remoteBank-container {
    background-color: #f5f5f7;
    .pc {
      .container {
        display: flex;
        justify-content: space-between;
        padding: 77px 0 76px;
        .content-left {
          flex: 1;
          font-family: PingFangSC-Medium, PingFang SC;
          color: #363636;
          margin-top: 29px;
          .title {
            font-size: 30px;
            font-weight: 500;
          }
          .subtitle {
            text-align: left;
            margin-top: 32px;
            font-size: 18px;
            font-weight: 400;
          }
          .btn-text {
            font-size: 18px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #08c6ad;
            cursor: pointer;
            margin-top: 45px;
          }
        }

        .content-right {
          flex: 1;
          margin-left: 132px;
          img {
            width: 502px;
            height: 337px;
          }
        }
      }
    }

    .mobile {
      .container {
        padding: 32px 0 32px;
        .top {
          font-family: PingFangSC-Medium, PingFang SC;
          color: #363636;
          margin-left: 20px;
          .title {
            font-size: 18px;
            font-weight: 500;
          }
          .subtitle {
            text-align: left;
            font-size: 13px;
            font-weight: 400;
            padding: 18px 32px 0 0;
          }
          .btn-text {
            width: 102px;
            height: 24px;
            border-radius: 3px;
            border: 1px solid #0ab49e;
            margin-top: 16px;
            font-size: 13px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #08c6ad;
            text-align: center;
          }
        }
        .bottom {
          margin: 30px 20px 0 20px;
          img {
            width: 335px;
            height: 225px;
          }
        }
      }
    }
  }
</style>
